import FactoryIcon from "../../icons/factoryIcon";
import MembersIcon from "../../icons/membersIcon";
import NetworkIcon from "../../icons/networkIcon";
import PlayIcon from "../../icons/playIcon";
import ScaleIcon from "../../icons/scaleIcon";
import ShipOutlineIcon from "../../icons/shipOutlineIcon";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import Popup from "../popups/popup";

const WhyUs = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  console.log(open, "open state");

  return (
    <article className="lg:h-[700px]  py-10 bg-white">
      <div className="relative z-10 flex flex-col items-center justify-center w-11/12 h-full gap-2 mx-auto lg:justify-between lg:flex-row ">
        <section className="order-2 space-y-4 lg:order-1">
          <h2 className="text-mainBlue text-[32px] font-bold my-10">
            {t("whyChooseUs?")}
          </h2>
          <div>
            <h3 className="flex items-center gap-2 text-lg">
              <NetworkIcon fill={"#0051FF"} width={24} /> {t("globalNetwork")}
            </h3>
            <p className="px-8 text-sm text-mainGray">{t("branchesAcrossEurope")}</p>
          </div>
          <div>
            <h3 className="flex items-center gap-2 text-lg">
              <ShipOutlineIcon className="size-6" /> {t("expertShipping")}
            </h3>
            <p className="px-8 text-sm text-mainGray">{t("specialistsInMoving")}</p>
          </div>
          <div>
            <h3 className="flex items-center gap-2 text-lg">
              <FactoryIcon /> {t("supportBeforeAndAfter")}
            </h3>
            <p className="px-8 text-sm text-mainGray">{t("weHelpWithLogistics")}</p>
          </div>
          <div>
            <h3 className="flex items-center gap-2 text-lg">
              <ScaleIcon /> {t("complianceWithLaws")}
            </h3>
            <p className="px-8 text-sm text-mainGray">
              {t("operationsWithLegalStandards")}
            </p>
          </div>
          <div>
            <h3 className="flex items-center gap-2 text-lg">
              <MembersIcon /> {t("memberOfTrusted")}
            </h3>
            <p className="px-8 text-sm text-mainGray">{t("partneredWithTopAgents")}</p>
          </div>
          <button
            onClick={() => setOpen(true)}
            className="flex items-center gap-2 px-4 py-2 text-xl font-bold text-white rounded-lg bg-mainRed w-fit"
          >
            <span>{t("watchVideo")}</span>
            <PlayIcon />
          </button>
        </section>
        <section className="order-1 lg:order-2">
          <img src="/assets/whyUs.png" alt="why us" />
        </section>
      </div>
      <Popup state={open} setState={setOpen}>
        <div className="relative p-4 bg-white rounded-lg asd ">
          <iframe
            src="https://drive.google.com/file/d/1Q3Eem1-6by9sV79QQr40ccftiVpReHb2/preview"
            className="w-full h-[350px] rounded-lg"
            allow="autoplay"
            title="Google Drive Video"
          ></iframe>
        </div>
      </Popup>
    </article>
  );
};

export default WhyUs;
